// The backend records a raw failure reason string on the patient when a
// demographics push to DoseSpot fails permanently. The common case is our own
// pre-validation rejecting a patient that is missing required fields (e.g.
// Height/Weight for a minor), which is self-healing once the fields are filled
// in. This maps that raw string into clinician-friendly banner copy.

const MISSING_FIELDS_PREFIX = 'Patient missing required DoseSpot fields:';

export interface DoseSpotSyncFailureCopy {
  headline: string;
  detail: string;
}

/**
 * Turn a raw DoseSpot demographics-sync failure reason into banner copy.
 *
 * For the missing-required-fields case we name the fields so the clinician
 * knows exactly what to add; everything else gets a generic message rather than
 * surfacing an internal error string.
 */
export function describeDoseSpotSyncFailure(reason: string): DoseSpotSyncFailureCopy {
  const trimmed = reason.trim();

  if (trimmed.startsWith(MISSING_FIELDS_PREFIX)) {
    const fields = trimmed.slice(MISSING_FIELDS_PREFIX.length).trim().replace(/\.$/, '');
    return {
      headline: 'Not syncing to DoseSpot',
      detail: fields
        ? `Add the missing ${fields} to resume e-prescribing.`
        : 'Missing required demographics for e-prescribing.',
    };
  }

  return {
    headline: 'Not syncing to DoseSpot',
    detail: 'A recent demographics change couldn’t be sent to DoseSpot.',
  };
}
